import { PlannerApi } from '../planner.api';
import type { ApiResponse, PlannerWatcher } from '@vision/ui/interfaces';
import type { PlannerTaskWatcherCreateArgs, PlannerTaskWatcherDeleteArgs } from './task-watchers.api.types';
import { buildCreateWatcherRequest, buildDeleteWatcherRequest } from './task-watchers.routes';

export const PlannerTaskWatcherEndpoints = PlannerApi.injectEndpoints({
  endpoints: (builder) => ({
    createWatcher: builder.mutation<ApiResponse<PlannerWatcher>, PlannerTaskWatcherCreateArgs>({
      query: buildCreateWatcherRequest,
    }),
    deleteWatcher: builder.mutation<void, PlannerTaskWatcherDeleteArgs>({
      query: buildDeleteWatcherRequest,
    }),
  }),
});

export const { useCreateWatcherMutation, useDeleteWatcherMutation } = PlannerTaskWatcherEndpoints;
